module.exports = __webpack_public_path__ + "profile-2-d-pxf.png";